// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"JN-z","loadingMedia":"KN-z","reviewsImagesAndVideos":"LN-z","limitHeight":"MN-z"};